import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function LegalLayout({ title, subtitle, updatedAt, children }) {
  return (
    <div className="bg-cream">
      <section className="container-editorial pt-16 md:pt-24 pb-8">
        <div className="max-w-3xl">
          <div className="eyebrow mb-6">Mentions & informations légales</div>
          <h1 className="font-display text-5xl md:text-6xl leading-tight text-anthracite">
            {title}
          </h1>
          {subtitle && (
            <p className="mt-6 text-lg text-anthracite/70 leading-relaxed">
              {subtitle}
            </p>
          )}
          {updatedAt && (
            <div className="mt-4 text-xs uppercase tracking-[0.22em] text-anthracite/40">
              Dernière mise à jour : {updatedAt}
            </div>
          )}
        </div>
      </section>

      <section className="container-editorial pb-16 md:pb-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          {/* Sidebar navigation */}
          <aside className="lg:col-span-3">
            <nav className="lg:sticky lg:top-24 border-l border-black/10 pl-5 space-y-3 text-sm">
              <div className="text-[10px] uppercase tracking-[0.28em] text-anthracite/40 mb-3">
                Documents légaux
              </div>
              <Link
                to="/mentions-legales"
                className="block text-anthracite hover:text-terracotta transition-colors"
              >
                Mentions légales
              </Link>
              <Link
                to="/confidentialite"
                className="block text-anthracite hover:text-terracotta transition-colors"
              >
                Confidentialité (RGPD)
              </Link>
              <Link
                to="/cgv"
                className="block text-anthracite hover:text-terracotta transition-colors"
              >
                Conditions générales de vente
              </Link>
              <div className="pt-6 mt-6 border-t border-black/10">
                <Link
                  to="/contact"
                  className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.22em] text-terracotta hover:text-copper transition-colors"
                >
                  Nous contacter
                  <ArrowUpRight className="w-3 h-3" strokeWidth={1.5} />
                </Link>
              </div>
            </nav>
          </aside>

          {/* Content */}
          <div className="lg:col-span-9 bg-white border border-black/10 p-8 md:p-12">
            <article className="legal-prose">
              {children}
            </article>
          </div>
        </div>
      </section>

      <style>{`
        .legal-prose { color: #1A1C20; font-size: 15px; line-height: 1.7; }
        .legal-prose h2 { font-family: "Playfair Display", serif; font-size: 1.75rem; letter-spacing: -0.01em; margin-top: 2.5rem; margin-bottom: 1rem; }
        .legal-prose h2:first-child { margin-top: 0; }
        .legal-prose h3 { font-family: "Manrope", sans-serif; font-weight: 600; font-size: 1rem; letter-spacing: 0.02em; text-transform: uppercase; color: #C05C3D; margin-top: 2rem; margin-bottom: 0.75rem; }
        .legal-prose p { margin: 0.75rem 0; color: rgba(26,28,32,0.85); }
        .legal-prose ul { list-style: none; padding-left: 0; margin: 0.75rem 0; }
        .legal-prose ul li { position: relative; padding-left: 1.25rem; margin: 0.5rem 0; color: rgba(26,28,32,0.85); }
        .legal-prose ul li::before { content: ""; position: absolute; left: 0; top: 0.7rem; width: 6px; height: 1px; background: #C05C3D; }
        .legal-prose a { color: #C05C3D; text-decoration: underline; text-underline-offset: 3px; }
        .legal-prose a:hover { color: #B87333; }
        .legal-prose strong { color: #1A1C20; font-weight: 600; }
        .legal-prose .callout { background: #F9F9F8; border-left: 3px solid #C05C3D; padding: 1rem 1.25rem; margin: 1.25rem 0; font-size: 14px; }
      `}</style>
    </div>
  );
}
